// src/NodeCallbackContext.js
// Context to provide node callback functions to deeply nested components
// This avoids prop drilling and prevents unnecessary re-renders

import React, { createContext, useContext } from 'react';

const NodeCallbackContext = createContext(null);

/**
 * Provider component that wraps the flow and supplies callbacks
 * @param {Object} props.callbacks - Object containing all node callback functions
 */
export function NodeCallbackProvider({ children, callbacks }) {
  return (
    <NodeCallbackContext.Provider value={callbacks}>
      {children}
    </NodeCallbackContext.Provider>
  );
}

/**
 * Hook to access node callbacks from any component within the provider
 * @returns {Object} callbacks - Object containing all node callback functions
 */
export function useNodeCallbacks() {
  const context = useContext(NodeCallbackContext);
  // Return empty object if used outside provider to prevent errors
  // Actual callbacks are still passed via node.data for backward compatibility
  return context || {};
}

export default NodeCallbackContext;
